import axiosInstance from "../../../../api/AxiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { changeOrderStatusRequest, changeOrderStatusRequestError, changeOrderStatusRequestSuccess } from "../../../slices/User/Detail/ChangeOrderStatusSlice";

export const ChangeOrderStatusAPI = (data) => async (dispatch) => {
    let id = ''
    if (data.orderId) {
        id = data.orderId
    }
    const urlWithParams = `${endpoints.changeOrderStatus}/${id}`;

    // const data = {
    //     status: status,
    //     scheduledDate: selectedDate,
    //     scheduledTime: selectedTime,
    //     deliveryCharges: deliveryCharges
    // }

    const payload = {};

    if (data.status) {
        payload.status = data.status
    }
    if (data.scheduledDate) {
        payload.scheduledDate = data.scheduledDate
    }
    if (data.scheduledTime) {
        payload.scheduledTime = data.scheduledTime
    }
    if (data.deliveryCharges) {
        payload.deliveryCharges = data.deliveryCharges
    }
    if (data.paymentType) {
        payload.paymentType = data.paymentType
    }
    if (data.remark) {
        payload.remark = data.remark
    }
    try {
        dispatch(changeOrderStatusRequest());
        // Returning the promise so we can await it in handleSubmit
        const response = await axiosInstance({
            method: "PUT",
            url: urlWithParams,
            data: payload,
            headers: { "Content-Type": "application/json" },
        })
        return dispatch(changeOrderStatusRequestSuccess(response.data));
    } catch (error) {
        const _error = {
            data: error?.response?.data?.message || error?.message,
            status: error?.response?.status || error?.status,
        };
        return dispatch(changeOrderStatusRequestError(_error));
    }
};
